import { TutorAdminResponse } from "client/openapi";
import TutorAvailability from "pages/tutors/availability";

/** The tutor's weekly hours, in the editor tutors use for themselves. */
export default function AvailabilityTab({
  tutor,
}: {
  tutor: TutorAdminResponse;
}) {
  if (!tutor.account_id) {
    return (
      <p className="mt-5 text-sm text-gray-600">
        This tutor hasn't created their Tadpole account yet, so availability
        can't be set.
      </p>
    );
  }
  return <TutorAvailability tutor={tutor} />;
}
